var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45593 0.977229L0.225371 7.20782C-0.0751237 7.50832 -0.0751237 7.9955 0.225371 8.29596L0.952066 9.02265C1.25205 9.32263 1.73823 9.32321 2.03892 9.02394L7.00002 4.08608L11.9611 9.02394C12.2618 9.32321 12.748 9.32263 13.0479 9.02265L13.7746 8.29596C14.0751 7.99546 14.0751 7.50828 13.7746 7.20782L7.5441 0.977229C7.24361 0.676766 6.75643 0.676766 6.45593 0.977229Z",
    fill: "#91DBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.650d9d1c2653f7bc4188d0fa60bab0ca.svg";
export { ForwardRef as ReactComponent };